'use strict';

angular.module('broadcastsModule')

.config(function (modalStateProvider)
{
    modalStateProvider.state('admin.broadcasters.edit-folder-thumb', {
        url: '/edit-folder-thumb/{id:[0-9]+}',
        controller: 'EditBroadcastsFolderCtrl',
        controllerAs: '$ctrl',
        templateUrl: 'broadcasters/broadcasters.modals/broadcasters.edit-folder.modal.html',
        resolve: {
            model: ['BroadcastsAsset', 'modalState', function (BroadcastsAsset, modalState)
            {
                return BroadcastsAsset.find(modalState.stateParams.id).then(function (data)
                {
                    modalState.model = data;
                    return modalState.model;
                });
            }],
            files: ['BroadcastsFile', 'modalState', function (BroadcastsFile, modalState)
            {
                var params = {broadcast_id: modalState.stateParams.id};
                BroadcastsFile.ejectAll(params);

                return BroadcastsFile.findAll(params);
            }],
            actions: ['Action', function (Action)
            {
                return Action.findAll();
            }]
        }
    });
});
